import { onMounted, onUnmounted } from 'vue'

export function useOnline(appStoreFn) {
  const appStore = appStoreFn()

  const updateOnlineStatus = (val) => {
    appStore.online = typeof val == 'boolean' ? val : val.target.online
  }

  navigator.onLine ? updateOnlineStatus(true) : updateOnlineStatus(false)

  onMounted(() => {
    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)
  })
  onUnmounted(() => {
    window.removeEventListener('online', updateOnlineStatus)
    window.removeEventListener('offline', updateOnlineStatus)
  })

  return {}
}
